import { render } from "./ConteudoGeralTemaView.vue?vue&type=template&id=0f719938&scoped=true"
import script from "./ConteudoGeralTemaView.vue?vue&type=script&lang=js"
export * from "./ConteudoGeralTemaView.vue?vue&type=script&lang=js"

import "./ConteudoGeralTemaView.vue?vue&type=style&index=0&id=0f719938&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f719938"]])

export default __exports__